"use strict";

/**
 * Show banner inside video list
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);

  /**
   * @returns {boolean}
   */
  function isEnabled() {
    var _Flix$routeArgs$page;
    return Flix.ads.enabled
    /** Only on the 1st page */ && ((_Flix$routeArgs$page = Flix.routeArgs['page']) !== null && _Flix$routeArgs$page !== void 0 ? _Flix$routeArgs$page : 1) == 1
    // Should be enough videos in the list
    && !!document.querySelector('.video-list [data-num="8"]');
  }

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    if (Flix.isTna()) {
      // mobile mediabuys only
      if (!FlixUtils.isMobile() || !Flix.ads.isSpecificBuy()) {
        return;
      }
    }
    var adBlock = document.createElement('div');
    adBlock.classList.add('col-xs-6', 'col-md-4', 'col-xl-3', 'mb-3');
    //width hack with remove jumping and it will not be visible when ad loaded.
    adBlock.innerHTML = "\n            <div class=\"_nativeAd\">\n                <img style=\"width:95%\" class=\"_nativePlaceholder\" src=\"/assets/img/empty.jpg\">\n                <span class=\"_nativeLabel\">AD</span>\n            </div>\n        ";
    document.querySelector('.video-list [data-num="8"]').insertAdjacentElement('afterend', adBlock.cloneNode(true));
    //Inh from legacy code
    document.querySelectorAll('._nativeAd').forEach(function (el) {
      FlixUtils.renderBannerAd(getZoneId(), el, 'eas6a97888e20', 'ad_error_video_list_banner');
    });
    setTimeout(function () {
      document.querySelector('._nativeAd').setAttribute('style', 'height:' + document.querySelector('.row.video-list>div').getBoundingClientRect().height + 'px;overflow:hidden;');
    });
  }
  function getZoneId() {
    return Flix.isTna() ? '4505268' : '4505270';
  }
})();